import React from 'react'
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Button } from '@mui/material'
import { ChecklistWrapper } from '../StyledComponents'
import { checklistData } from '../data';

function Checklist() {
	return (
		<ChecklistWrapper>
			<Box className="title">Forms / checklists</Box>
			<Box className="content">
				{checklistData.map((item, index) => (
					<p key={`${item.label}_${index}`}>{item.label}</p>
				))}
			</Box>
			<Button endIcon={<ChevronRightIcon />}>View More</Button>
		</ChecklistWrapper>
	)
}

export default Checklist
